module.exports = __webpack_public_path__ + "static/media/raf.73690982.png";